import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, UseFormReturn } from 'react-hook-form';
import { dayjsToPayloadFormat } from 'web-library';
import { candidateService } from '../../../api';
import { SearchDate } from '../../../models';
import { Dayjs } from 'dayjs';
import searchTransactionLogSchema from '../../../models/@admin/searchTransactionLogSchema';

export interface DateInput {
  startDate: string;
  endDate: string;
}
export interface EditDeleteReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */
  submitSearch: (submitData: any) => void;
  /**
   * Form to send edit & delete
   */
  form: UseFormReturn<DateInput>;

  /**
   * React query mutation object
   */
  auditSearchListMutation: any;
}

/**
 * A hook to handle search functionality
 * @returns
 */
export const useSearchFunction = (): EditDeleteReturn => {
  const form = useForm<DateInput>({
    mode: 'onSubmit',
    resolver: joiResolver(searchTransactionLogSchema),
  });

  const auditSearchListMutation = candidateService.audit.opadmin.useAuditSearchList(
    () => {
      // do nothing
    },
    () => {
      // do nothing
    }
  );

  const submitSearch = (submitData: SearchDate) => {
    auditSearchListMutation.mutate({
      size: 5,
      page: 0,
      startDate: submitData.startDate,
      endDate: submitData.endDate,
    });
  };

  return {
    form,
    submitSearch,
    auditSearchListMutation,
  };
};
